import { FC } from "react";

import S from "./Container.module.scss";
import { ContainerProps } from "./types";

export const Container: FC<ContainerProps> = ({ children }) => <div className={S.Container}>{children}</div>;
